module.exports = __webpack_public_path__ + "UVLogo-667a06b97872bfbc3445b88da68abee0.png";